<div class="email-attachment-list">
  <div class="email-attachment" *ngFor="let attachment of attachments">
    <a
      class="email-attachment-filename"
      href="javascript:void(0)"
      (click)="previewOrDownloadAttachment(attachment)"
      [class.Uploading]="isUploading(attachment)"
      [class.disabled]="isDisabled"
    >
      <div sa-ellipsis one-time="true" [fullText]="getFileDisplayName(attachment) || getFileName(attachment)"></div>
    </a>
    <div class="email-attachment-filesize" [class.disabled]="isDisabled">
      ({{ getFileSize(attachment) | xsFileSizeFormatPipe }})
    </div>

    <span
      *ngIf="showClose"
      [class.disabled]="isDisabled"
      (click)="deleteAttachment(attachment)"
      class="hd-icon hd-icon-close icon-md attachment-icon no-gutter"
    ></span>
    <span *ngIf="!showClose" class="attachment-icon no-gutter"></span>
  </div>
</div>
